import { useEffect } from 'react'
import { OneMessage, OneMessage as SLMessage } from '@yy/one-ui'
import http from '@/services/http'
import { useTranslation } from 'react-i18next'
import { logout } from '@/store/authSlice'
import { useDispatch } from '@/store'
import { useHistory } from 'react-router'
import i18n from '@/i18n'

// 不需要全局拦截提示toast的code
// stoken过期: -13， 已注册：2002
const udbWhiteCode = ['-13', '2002']
/** 远程错误 Remote error */
const adminWhiteCode = ['LST-133242-G0001']
const GlobalError = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()

  // admin HTTP 拦截器
  useEffect(() => {
    const id = http.admin.interceptors.response.use(
      (response) => {
        return response
      },
      (rejection) => {
        const shouldToast = !adminWhiteCode.includes(rejection?.code) && rejection?.code

        // 商家未创建
        //TODO: 可以改成用adminWhiteCode，或者用其他的变量进行赋值，避免魔法字符
        if (rejection?.code === 'LST-133242-G0001' && window.location.pathname !== '/noAuth') {
          window.location.replace('/noAuth')
        }
        if (shouldToast) {
          const i18nResult = t([`system.error.${rejection.code}`, rejection.code /*fallback*/], { systemError: rejection.message })

          // 只有匹配到指定的多语言code，才全局提示
          // rejection.code !== t(system.error.rejection.code)
          if (i18nResult === t(`system.error.${rejection.code}`, { systemError: rejection.message })) {
            if (
              // 魔法字符
              // TODO:剔除掉登录信息
              !['LST-133242-B9001' /*no login*/, 'LST-133242-B9003'] /*cookie expired*/
                .includes(rejection.code)
            ) {
              SLMessage.error(i18nResult)
            }
            // TODO: 可以与上面的if合并为1个
            switch (rejection.code) {
              case 'LST-133242-B9001' /*no login*/:
                location.href = `${process.env.ONECLUB_URL}/user/login?&app=ow&lang=${i18n.language}`
                break
              case 'LST-133242-B9003' /*cookie expired*/:
                dispatch(logout(`${process.env.ONECLUB_URL}/user/login?&app=ow&lang=${i18n.language}`))
                break
            }

            // 修改数据，去掉message等，避免在发起请求者的catch中再次提示message
            return Promise.reject({
              data: null,
              code: rejection.code,
            })
          }

          // 请求有添加toast config的，提示message

          if (rejection.config?.toast) {
            rejection?.message && OneMessage.error(rejection?.message)
          }
        }
        return Promise.reject(rejection)
      }
    )

    return () => {
      /** 取消响应逻辑 */
      http.admin.interceptors.response.eject(id)
    }
  }, [dispatch, history, t])

  // udb拦截器
  useEffect(() => {
    const id = http.udb.interceptors.response.use(
      (response) => response,
      (rejection) => {
        const shouldToast = !udbWhiteCode.includes(rejection?.rescode) && rejection?.rescode
        if (shouldToast) {
          const i18nResult = t([`udb.rescode.${rejection.rescode}`, rejection.resmsg /*fallback*/])

          // 只有匹配到指定的多语言code，才全局提示
          if (i18nResult === t(`udb.rescode.${rejection.code}`)) {
            SLMessage.error(i18nResult)

            // 修改数据，去掉message等，避免在发起请求者的catch中再次提示message
            return Promise.reject({
              data: null,
              code: rejection.code,
            })
          }
        }

        return Promise.reject(rejection)
      }
    )

    return () => {
      http.admin.interceptors.response.eject(id)
    }
  }, [t])

  return null
}
GlobalError.displayName = 'GlobalError'

export default GlobalError
